module.exports = __webpack_public_path__ + "static/thumbnail_02_sprite.a57d0a6e.png";